
import { defineComponent, computed } from 'vue'
import ColorPicker from './ColorPicker.vue'
export default defineComponent({
  components: {
    ColorPicker
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  emits: ['change'],
  setup(props, context) {
    const values = computed(() => {
      // box shadow should like this
      // 10px 10px 0px red;
      // the first two should be sizes
      // the 3rd one should be blur
      // the last one should be color
      return props.value.split(' ')
    })
    const updateValue = (newValue: number | string, index: number | number[]) => {
      const newValues = computed(() => {
        return values.value.map((item, i) => {
          if (typeof index === 'number' && i === index) {
            return typeof newValue === 'number' ? newValue + 'px' : newValue
          } else if (Array.isArray(index) && index.includes(i)) {
            return typeof newValue === 'number' ? newValue + 'px' : newValue
          } else {
            return item
          }
        })
      })
      context.emit('change', newValues.value.join(' '))
    }
    return {
      values,
      updateValue
    }
  }
})
